// drag-order.ts — Calcul pur d'un réordonnancement par glisser-déposer.
//
// Séparé du câblage DOM (utils/drag-order.ts) pour être testable sans
// événements de drag, que les environnements de test simulent mal.

/**
 * Déplace `srcId` à la place de `targetId`.
 *
 * Sémantique alignée sur le comportement des tables existantes : en
 * descendant, l'élément se pose APRÈS la cible ; en remontant, AVANT. C'est ce
 * qui donne l'impression que l'élément « prend la place » de celui qu'on
 * survole, dans les deux sens.
 *
 * Retourne la liste inchangée si l'un des deux ids est absent, ou s'ils sont
 * identiques.
 */
export function moveTo(ids: readonly number[], srcId: number, targetId: number): number[] {
  const from = ids.indexOf(srcId);
  const to = ids.indexOf(targetId);
  if (from < 0 || to < 0 || from === to) return [...ids];
  const out = [...ids];
  const [moved] = out.splice(from, 1);
  if (moved === undefined) return [...ids];
  // Après le retrait, les index au-delà de `from` ont glissé d'un cran : on
  // insère donc à `to` quand on descend, et à `to` aussi quand on remonte —
  // l'ajustement est absorbé par le splice.
  out.splice(to, 0, moved);
  return out;
}
